import DatePick_MI from 'components/DatePicker_MI'
import React, { useContext, useState } from 'react'
import "./RequestedRemovalQuestions.css"

const RequestedRemovalQuestions = ({ requestContext, vehicleContext, endorsementType }) => {
    const requestTypeContext = useContext(requestContext)
    const deleteVehicleContext = useContext(vehicleContext)
    const [requestedRemovalEffDate, setRequestedRemovalEffDate] = useState(requestTypeContext.getTodaysDate(true))

    return (
        <>
            {/* Requested Effective Date (Required) */}
            <div className='col-xl-12 justify-content-center'>
                <div className="row form-group form-group-sm align-items-center my-4">
                    <p className="col-12 col-md-6 col-sm-12 text-primary fw-bold mb-2 mb-md-0 vehicleQuestions">
                        Requested Remove Vehicle Effective Date*
                    </p>
                    <div className="col-12 col-md-6 col-sm-12">
                        <DatePick_MI
                            dateSubmit={deleteVehicleContext?.deleteVehicle?.requestedRemovalEffDate ? deleteVehicleContext?.deleteVehicle?.requestedRemovalEffDate : requestedRemovalEffDate}
                            setDateSubmit={setRequestedRemovalEffDate}
                            storeValue={deleteVehicleContext?.removeVehCallback}
                            nameValue={"requestedRemovalEffDate"}
                            displayCalendar={"bottom-start"}
                        />
                    </div>
                </div>
            </div>

            {/* Removal Reason (Required) */}
            <div className='col-xl-12 justify-content-center'>
                <div className="row form-group form-group-sm align-items-center my-4">
                    <p className="col-12 col-md-6 col-sm-12 text-primary fw-bold mb-2 mb-md-0 vehicleQuestions">
                        What is the primary reason for removing this vehicle?*
                    </p>
                    <div className="col-12 col-md-6 col-sm-12">
                        <select className="btn btn-default btn-group dropdown-toggle filter-option"
                            value={deleteVehicleContext?.deleteVehicle?.vehicleRemovalReason ? deleteVehicleContext?.deleteVehicle?.vehicleRemovalReason : ""}
                            onChange={(e) => { deleteVehicleContext?.removeVehCallback("vehicleRemovalReason", e.target.value) }}
                        >
                            <>
                                <option value="" disabled>Select from the following...</option>
                                <option value="Sold/Gifted/Donated">Sold/Gifted/Donated</option>
                                <option value="Traded In/Lease Ended/Returned to Dealer/Repossessed">Traded In/Lease Ended/Returned to Dealer/Repossessed</option>
                                <option value="Garaged/Placed in storage">Garaged/Placed in storage</option>
                                <option value="Totaled in an accident/Stolen">Totaled in an accident/Stolen</option>
                                <option value="Mechanical Failure/Not Running">Mechanical Failure/Not Running</option>
                                <option value="Divorce/Separation and now insured on another policy">Divorce/Separation and now insured on another policy</option>
                                <option value="Other">Other</option>
                            </>
                        </select>
                    </div>
                </div>
            </div>

            {/* Please Explain Field (Not Required) */}
            <div className='col-xl-12 justify-content-center'>
                <div className="row form-group form-group-sm align-items-center my-4">
                    <p className="col-12 col-sm-6 text-primary fw-bold mb-2 mb-md-0 vehicleQuestions">
                        Please explain...
                    </p>
                    <div className="col-12 col-md-6 col-sm-12">
                        <textarea className="form-control" placeholder="Please explain..."
                            style={{ resize: 'none' }}
                            value={deleteVehicleContext?.deleteVehicle?.vehicleRemovalExplanation ? deleteVehicleContext?.deleteVehicle?.vehicleRemovalExplanation : ""}
                            onChange={(e) => { deleteVehicleContext?.removeVehCallback("vehicleRemovalExplanation", e.target.value) }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default RequestedRemovalQuestions